export default "__VITE_ASSET__mh$PRX6I__"